/* Navigation enhancement. Native destination links remain available without JS. */
if (!customElements.get('hellsewn-navigation')) customElements.define('hellsewn-navigation', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const opts = {signal:this.abort.signal};
    this.header=this.closest('header'); this.panel=this.querySelector('.hv-nav-shell');
    this.openButton=this.header.querySelector('[data-nav-open]'); this.toggleButton=this.querySelector('[data-nav-toggle]');
    this.backdrop=this.querySelector('[data-nav-backdrop]');
    const breakpoint=getComputedStyle(document.documentElement).getPropertyValue('--bp-desktop').trim();
    this.desktop=matchMedia(`(min-width:${breakpoint})`); this.expanded=false;
    this.update=()=>{
      const open=this.desktop.matches?this.expanded:this.mobileOpen;
      this.panel.hidden=!open;this.backdrop.hidden=this.desktop.matches||!open;
      document.body.classList.toggle('hv-nav-open',!this.desktop.matches&&Boolean(open));
      this.header.dataset.navOpen=String(Boolean(open));this.dataset.expanded=String(this.expanded);
      this.openButton.setAttribute('aria-expanded',String(Boolean(open)));
      this.toggleButton.setAttribute('aria-expanded',String(this.expanded));
      if(!this.desktop.matches&&open){this.panel.setAttribute('role','dialog');this.panel.setAttribute('aria-modal','true');this.panel.setAttribute('aria-label','Hellsewn navigation');}
      else{this.panel.removeAttribute('role');this.panel.removeAttribute('aria-modal');this.panel.removeAttribute('aria-label');}
      this.header.dispatchEvent(new Event('hellsewn:nav'));
    };
    this.close=(restore=true)=>{this.mobileOpen=false;if(!this.desktop.matches&&restore)this.openButton.focus();this.update();};
    this.openButton.addEventListener('click',()=>{this.mobileOpen=true;this.update();this.querySelector('[data-nav-close]').focus();},opts);
    this.querySelector('[data-nav-close]').addEventListener('click',()=>this.close(),opts);
    this.backdrop.addEventListener('click',()=>this.close(),opts);
    this.toggleButton.addEventListener('click',()=>{this.expanded=!this.expanded;this.update();},opts);
    this.desktop.addEventListener('change',()=>{this.mobileOpen=false;this.update();},opts);
    this.panel.addEventListener('click',event=>{if(event.target.closest('a'))this.close(false);},opts);
    document.addEventListener('keydown',event=>{
      if(this.desktop.matches||!this.mobileOpen)return;
      if(event.key==='Escape'){event.preventDefault();this.close();}
      if(event.key==='Tab'){
        const links=[...this.panel.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]')].filter(node=>node.getClientRects().length&&!node.hidden);
        const first=links[0],last=links.at(-1);
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    },opts);
    this.update();
  }
  disconnectedCallback(){this.abort?.abort();document.body.classList.remove('hv-nav-open');}
});
